<div class="title-main-container">
    <div class="title-main-content small-wrapper">
        <div class="title-main-content-header">
            {{ title }}
        </div>
        @if (subtitle) {
        <div class="title-main-content-subtitle">
            {{ subtitle }}
        </div>
        }
    </div>
</div>
